import React, {ReactNode, useState, useMemo } from 'react';
import {
    DrawerContent,
    InputDisplay,
    InputWrapper,
    ListContentWrapper,
    PrefixIconWrapper
} from "./styles";
import SelectSearches from "./SelectSearches";
import {useStore} from "../../store/global/appStore";
import {Label} from "../CustomAntdComponents/StyledInput/styles";
import MobileBottomSheet from '../MobileBottomSheet/MobileBottomSheet';

type Props = {
    label: string,
    placeholder?: string,
    defaultValue?: string,
    options: SelectOption[],
    onChange?: (value: any) => void;
    suffixIcon?: ReactNode,
    value?: string | number,
    renderIcon: () => ReactNode,
    tripType: string,
    mode: string,
    allowMultipleDestinations?: boolean,
    disabled?: boolean,
    onAddMultipleDestinations?: () => void
}

const MobileRouteSelector = ({ label, tripType, value, options, onChange, renderIcon, mode, allowMultipleDestinations, disabled, onAddMultipleDestinations }: Props) => {
    const [isOpen, setIOpen] = useState(false);
    const [searchText, setSearchText] = useState("");
    const { airports} = useStore();

    const handleSelect = (value: any) => {
        onChange?.(value);
        setIOpen(false);
        setSearchText("");
    }

    const displayValue = useMemo(() => {
        if(tripType === "road"){
            return options.find((option) => option.value === value)?.label;
        }

        const airport = airports.find((option) => option.Code === value);if(airport){
            return `${airport.Code}, ${airport.StateName}`;
        }

        if(value) {
            return value.toString();
        }

        return '';
    }, [value, airports, options, tripType]);

    return (
        <div>
            <InputWrapper onClick={() => setIOpen(true)}>
                <PrefixIconWrapper>
                    {renderIcon()}
                    <Label>
                        {`${label}: `}
                    </Label>
                </PrefixIconWrapper>
                <InputDisplay>
                    {displayValue}
                </InputDisplay>
            </InputWrapper>

            <MobileBottomSheet
                open={isOpen}
                onClose={() => {
                    setSearchText("");
                    setIOpen(false);
                }}
                title={mode === "from" ? "Where are you departing from?" : "Where is your destination?"}
                className="route-selector-bottom-sheet"
                height="calc(100dvh - 68px)"
            >
                <DrawerContent className="route-selector-sheet-content">
                    <ListContentWrapper className="route-selector-list-content">
                        {
                            tripType === 'road' ? (
                                null

                            ) : (
                                <SelectSearches
                                    onSelect={handleSelect}
                                        searchText={searchText}
                                        mode={mode}
                                        allowMultipleDestinations={allowMultipleDestinations}
                                        disabled={disabled}
                                        onAddMultipleDestinations={onAddMultipleDestinations}
                                        setIsOpen={setIOpen}
                                        setSearchText={setSearchText}
                                        isMobileView
                                        showTitle={false}
                                />
                            )
                        }
                    </ListContentWrapper>
                </DrawerContent>
            </MobileBottomSheet>
        </div>
    );
};

MobileRouteSelector.defaultProps = {
    placeholder: undefined,
    defaultValue: undefined,
    suffixIcon: undefined,
    value: undefined,
    onChange: undefined,
};

export default MobileRouteSelector;
